import { render, staticRenderFns } from "./ClassInstructor.vue?vue&type=template&id=ac324cc6&"
import script from "./ClassInstructor.vue?vue&type=script&lang=js&"
export * from "./ClassInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports